import { createSlice } from "@reduxjs/toolkit";

type Payload = {
  search: string;
};

type State = {
  payload: Payload;
};

const slice = createSlice({
  name: "searchStakeholders",
  initialState: { payload: { search: "" } } as State,
  reducers: {
    setSearchStakeholders: (state, { payload }: { payload: Payload }) => {
      state.payload = payload;
    }
  }
});

export const { setSearchStakeholders } = slice.actions;
export default slice.reducer;
